import screen0 from "./screens/client-purchase-reports.png";
import screen1 from "./screens/logistics-review-alerts.png";
import screen2 from "./screens/crm-next-action.png";

export const UPDATE_SCREENS = {
	"client-purchase-reports": { src: screen0, ...{"width": 1000, "height": 650, "rect": {"x": 708.71875, "y": 447.75, "width": 150.28125, "height": 36}, "crop": {"x": 104, "y": 129.25, "width": 792, "height": 391.5}} },
	"logistics-review-alerts": { src: screen1, ...{"width": 400, "height": 900, "rect": {"x": 73, "y": 304.6953125, "width": 112.09375, "height": 40}, "crop": {"x": 24, "y": 148.6953125, "width": 256, "height": 388}} },
	"crm-next-action": { src: screen2, ...{"width": 700, "height": 1200, "rect": {"x": 615.9921875, "y": 429, "width": 51.0078125, "height": 32}, "crop": {"x": 36, "y": 404, "width": 656, "height": 578}} },
} as const;
